export enum ResourcePacksOptions {
  DigitalWorkbook = 'DigitalWorkbook',
  PrintWorkbookExpress = 'PrintWorkbookExpress',
  PrintWorkbookStandard = 'PrintWorkbookStandard',
}
